import { render, staticRenderFns } from "./TemplatesCard.vue?vue&type=template&id=9ed01934&"
import script from "./TemplatesCard.vue?vue&type=script&lang=ts&"
export * from "./TemplatesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports